import { Link } from 'react-router-dom'
import { Card, CardBody } from '../components/ui/Card'
import { Logo } from '../components/Logo'
import { useTheme } from '../lib/theme'
import { Seo } from '../components/Seo'

export const seoTitle = 'Terms of Service'
export const seoDescription =
  'The terms that apply to using RemindLoop, the WhatsApp and SMS invoice reminder service.'

export default function Terms() {
  const { theme } = useTheme()
  return (
    <div className="mx-auto max-w-2xl px-4 py-10">
      <Seo title={seoTitle} description={seoDescription} path="/terms" />
      <div className="mb-6 flex justify-center">
        <Logo size={34} reversed={theme === 'dark'} />
      </div>
      <Card>
        <CardBody className="space-y-4">
          <h1 className="text-h1 text-foreground">Terms of Service</h1>
          <p className="text-sm text-muted-foreground">
            Placeholder — this page stands in for the real Terms of Service, which have not been
            drafted yet. By creating an account you agree to these terms as they will be published
            here.
          </p>
          <p className="text-sm text-muted-foreground">
            RemindLoop provides pre-collection reminder tooling for organisations, sending
            WhatsApp/SMS notifications to their clients on their behalf based on rules the
            organisation configures. Real terms covering acceptable use, data handling, liability,
            and cancellation will replace this text before general availability.
          </p>

          <h2 className="text-h2 text-foreground">
            Data processing relationship (POPIA operator &amp; responsible party)
          </h2>
          <p className="text-sm text-muted-foreground">
            For personal information belonging to your own customers or debtors — names, phone
            numbers, email addresses, and invoice details you upload or connect to RemindLoop
            (whether via CSV/XLSX import or an accounting integration such as Xero, Sage, or
            QuickBooks) — <strong>you are the "responsible party"</strong> under South Africa's
            Protection of Personal Information Act (POPIA), and RemindLoop acts only as your
            {' '}<strong>"operator"</strong>: we process that information solely to provide the
            reminder service, on your instructions, and do not decide the purposes for which it is
            processed.
          </p>
          <p className="text-sm text-muted-foreground">
            As the responsible party, you are responsible for having a lawful basis to process
            your customers' personal information and to share it with us, including obtaining any
            consent your own customers require under POPIA or otherwise. This includes the
            accuracy of any declaration you make within the product that you have already obtained
            your customers' consent to be contacted over WhatsApp — see your account's WhatsApp
            consent settings. RemindLoop relies on your declaration as given and does not
            independently verify it; you, not RemindLoop, bear responsibility for that declaration
            being accurate. Where you have not made that declaration, RemindLoop runs its own
            opt-in step before messaging a debtor over WhatsApp on your behalf, as described in
            your account's WhatsApp consent settings.
          </p>
          <p className="text-sm text-muted-foreground">
            This section is a placeholder describing the intended data-processing relationship
            between you and RemindLoop. It has not been reviewed by an attorney, is not legal
            advice, and will be replaced by fully drafted terms before general availability. See
            our{' '}
            <Link to="/operator-agreement" className="text-brand-700 underline underline-offset-2 hover:text-brand-800">
              Operator Agreement
            </Link>{' '}
            for the standalone version of this section. If you are unsure of your own obligations
            as a responsible party under POPIA, confirm with your own attorney.
          </p>

          <Link to="/" className="inline-block text-sm font-medium text-brand-700 hover:underline">
            ← Back to home
          </Link>
        </CardBody>
      </Card>
    </div>
  )
}
